import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import omit from "lodash/omit";
import type { IBrowser, Tuple } from "@litres-libs/types";

import type { RootState } from "../../store";
import { addHydrateReducer } from "../../utils/hydrateReducer";

const initialState: IBrowser = {
  screen: {
    width: null,
    height: null,
  },
  urlParams: {},
  pda: false,
  clientHost: "www.litres.ru",
  headers: {},
  isRobot: false,
};

export const getGlobalHeaders = (state: RootState): IBrowser["headers"] =>
  state.browser.headers;

export const browserSlice = createSlice({
  name: "browser",
  initialState,
  reducers: {
    setBrowserParams: (
      state: IBrowser,
      action: PayloadAction<Partial<IBrowser>>
    ) => ({ ...state, ...action.payload }),
    setHeader: (
      state: IBrowser,
      { payload: newHeader }: PayloadAction<Tuple<string, string>>
    ) => {
      const [name, value] = newHeader;
      state.headers = {
        ...state.headers,
        [name]: value,
      };
    },
    removeHeader: (
      state: IBrowser,
      { payload: headerName }: PayloadAction<keyof IBrowser["headers"]>
    ) => {
      state.headers = omit(state.headers, [headerName]);
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "browser");
  },
});

export const { setBrowserParams, setHeader, removeHeader } =
  browserSlice.actions;

export default browserSlice.reducer;
